import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PortfolioPage from './pages/PortfolioPage';
import SummaryPage from './pages/SummaryPage';
import ConditionsPage from './pages/ConditionsPage';
import MarketPage from './pages/MarketPage';
import HistoryPage from './pages/HistoryPage';
import TodayBriefPage from './pages/TodayBriefPage';

/**
 * 路由配置
 * 7 个页面路由：
 * /              → 首页（买入候选看板）
 * /today-brief   → 今日简报（卖出/买入/成交/盈亏）
 * /portfolio     → 持仓监控
 * /market        → 股票看板（全市场行情）
 * /conditions    → 条件管理
 * /history       → 历史数据下载
 * /summary       → 投资总结
 */
export const routes = (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/today-brief" element={<TodayBriefPage />} />
    <Route path="/portfolio" element={<PortfolioPage />} />
    <Route path="/market" element={<MarketPage />} />
    <Route path="/conditions" element={<ConditionsPage />} />
    <Route path="/history" element={<HistoryPage />} />
    <Route path="/summary" element={<SummaryPage />} />
  </Routes>
);
